import * as z from "zod";

export const getOutboundLabelsMetrics = {
  name: "getOutboundLabelsMetrics" as const,
  input: z.object({ since: z.date() }),
  output: z.object({
    totalOrders: z.number(),
    totalShippingCost: z.number(),
    averageShippingCostPerOrder: z.number(),
  }),
};
